import React from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { useNavigationItems } from '../../../hooks/useNavigationItems';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navItems = useNavigationItems();

  return (
    <nav className="hidden md:flex flex-1 justify-center">
      <div className="flex items-center gap-8">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <motion.div
              key={item.name}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link
                to={item.path}
                data-tour={`nav-${item.path === '/' ? 'dashboard' : item.path === '/integracoes' ? 'integrations' : item.path === '/ia' ? 'ia' : item.path === '/leads-salvos' ? 'leads-salvos' : ''}`}
                className={`text-sm font-medium leading-normal transition-colors relative ${isActive
                  ? 'text-primary'
                  : 'text-[#181411] dark:text-gray-300 hover:text-primary dark:hover:text-primary'
                  }`}
              >
                <span className="material-symbols-outlined text-lg mr-1">
                  {item.icon}
                </span>
                {item.name}
                {isActive && (
                  <motion.div
                    className="absolute -bottom-3 left-0 right-0 h-0.5 bg-primary"
                    layoutId="underline"
                    initial={false}
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
              </Link>
            </motion.div>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;